import { Timestamp } from '../firebase'

export const formatDateToYYYYMMDD = (date: Date | Timestamp): string => {
  const d = date instanceof Date ? date : date.toDate()
  const year = d.getFullYear()
  const month = (d.getMonth() + 1).toString().padStart(2, '0') // months are 0-indexed in JavaScript
  const day = d.getDate().toString().padStart(2, '0')
  return `${year}年${month}月${day}日`
}
